import { defineStore } from "pinia";
import { client, urls, RBACclient } from "@/apiClient";
import { useBrandsStore } from "./brands";
import { urls as iamUrls } from "../modules/UserManagement/urls";

export const usePermissionStore = defineStore("permissions", {
  state: () => ({
    permissions: null,
    permissionLoader: true,
    isBrandAdmin: false
  }),
  actions: {
    async fetchPermissions(brandId, enableUserManagement) {
      this.permissionLoader = true;
      try {
        if (enableUserManagement) {
          const { data } = await RBACclient.get(iamUrls.getProfilePermissions(brandId));
          this.permissions = data.permissions;
          this.isBrandAdmin = data.isBrandAdmin;
        } else {
          const { data } = await client.getLatest(urls.permissions, { params: { brandId: brandId },});
          this.permissions = data.permissions;
          this.isBrandAdmin = data.isBrandAdmin;
        }
        this.permissionLoader = false;
      } catch(e){
        this.permissionLoader = false;
      }
    },
    checkAuthorization(newSlug, oldSlug = "") {
      const brands = useBrandsStore();
      if (brands.selectedBrand?.flags.enableUserManagement) {
        if(Array.isArray(newSlug)) {
          return newSlug.some(permission => (this.permissions || []).includes(permission))
        }
        return this.permissions?.includes(newSlug);
      } else {
        return oldSlug ? this.permissions?.includes(oldSlug) : true;
      }
    },
  },
});
